module.exports = __webpack_public_path__ + "img/badge-list-thumb-017.891f1d34.png";